// 工具方法
$(window).on('scroll', function () {
    $('#zg-header').offset({
        left: 0
    })
});
$.extend({

});
$.fn.extend({
    setOwlSlider: function (items, config) {
        items = items || 1;
        if (typeof items == 'object') {
            config = items;
            items = 1;
        }

        if ($(this).children().length <= items) {
            return;
        }

        config = $.extend({
            loop: true,
            margin: 0,
            nav: false,
            // autoplay: true,
            smartSpeed: 1600,
            autoplayHoverPause: true,
            responsive: {
                0: {
                    items: items
                }
            }
        }, config);
        $(this).addClass('owl-carousel owl-theme').owlCarousel(config);
    },
    setScorllBar: function (config) {
        // $.each(this, function (i, e) {
        //     $(e).wrapInner('<div class="iscroll_container"></div>');
        //     var myScroll = new IScroll($(e).find('.iscroll_container')[0], {
        //         mouseWheel: true,
        //         scrollbars: true
        //     });
        // });
        config = $.extend({
            autoHideScrollbar: true
        }, config);
        $(this).mCustomScrollbar(config);
    },
    setAnimate: function (className, animateClass, config) {
        $(this).addClass(className + ' ' + animateClass);

        $(this).each(function (i, e) {
            $(e).attr('data-wow-delay', config.delay * i + 's');
            $(e).attr('data-wow-duration', config.duration);
        });
        config = $.extend({
            boxClass: className,
            animateClass: 'animated',
            offset: 0,
            mobile: true,
            live: true
        }, config);

        let wow = new WOW(config);
        return {
            run: function () {
                wow.init();
            }
        };
    },
    parallaxDom: function (initPos, rota) {
        initPos = initPos || 80;
        rota = rota || 1.8;
        var top = $(this).offset().top,
            h = $(this).outerHeight(true);

        var _this = this;

        $(window).on('scroll', function (ev) {
            var scrollT = $(this).scrollTop();
            if (!$(_this).data('inner') && (scrollT + $(window).height()) > (top + initPos)) {
                $(_this).data('inner', true);
                $(_this).css({
                    'transform': 'translate3D(0, ' + initPos + 'px, 0)'
                });
            }
            scrollDo(ev, scrollT);
            if ($(_this).data('inner')) {}
            // if ($(_this).data('inner') && scrollT > (top + h - initPos)) {
            //     $(_this).data('inner', false);
            // }
        });

        function scrollDo(ev, sT) {
            var dis = 80 + (sT - (top + initPos)) / rota;
            $(_this).css({
                'transform': 'translate3D(0, ' + dis + 'px, 0)'
            });
        }
    },
    tabClass: function (className1, className2) {
        $(this).each(function (i, e) {
            if ($(e).hasClass(className1)) {
                $(e).removeClass(className1).addClass(className2);
            } else {
                $(e).removeClass(className2).addClass(className1);
            }
        });
    }
});

// 私有工具方法
let tools = {
    showMinH: function () {
        if ($(window).scrollTop() > 10) {

            $('.zg-header').addClass('min');
        } else {

            $('.zg-header').removeClass('min');
        }
    },
    getTrendData: function (cb) {
        $.ajax({
            type: "GET",
            url: "./js/mockdata.json",
            success: function (data) {

                cb && cb(JSON.parse(data.data));
            },
            error: function () {
                // 这里为了在本地浏览的时，ajax 无法请求时展现；（最终需要删除）
                cb && cb([
                    [1527550885000, 90.3318],
                    [1527551485000, 91.0037],
                    [1527552085000, 89.0781],
                    [1527552685000, 89.498],
                    [1527553285000, 90.0249],
                    [1527553885000, 91.3002],
                    [1527554485000, 91.4024],
                    [1527555085000, 91.4024],
                    [1527555685000, 91.4393],
                    [1527556285000, 91.4571],
                    [1527556885000, 91.5036],
                    [1527557485000, 91.5472],
                    [1527558085000, 91.5775],
                    [1527558685000, 91.5896],
                    [1527559285000, 91.4367],
                    [1527559885000, 91.5896],
                    [1527560485000, 91.5931],
                    [1527561085000, 91.6086],
                    [1527561685000, 91.436],
                    [1527562285000, 90.5334],
                    [1527562885000, 90.4403],
                    [1527563485000, 89.6287],
                    [1527564085000, 89.3138],
                    [1527564685000, 89.4724],
                    [1527565285000, 90.702],
                    [1527565885000, 91.62],
                    [1527566485000, 91.6388],
                    [1527567085000, 91.6868],
                    [1527567685000, 91.7172],
                    [1527568285000, 91.7407],
                    [1527568885000, 86.8248],
                    [1527569485000, 87.1846],
                    [1527570085000, 86.6624],
                    [1527570685000, 87.6307],
                    [1527571285000, 88.3623],
                    [1527571885000, 88.3988]
                ]);
            }
        });
    },
    /**
     * dom 显示的走势图所在元素
     * renderEnd 渲染执行后的回调
     */
    renderTrendLine: function (dom, renderEnd) {
        this.getTrendData($.proxy(function (data) {
            this._renderTrendLine(data, dom, renderEnd);
        }, this));
    },
    _renderTrendLine: function (data, dom, renderEnd) {

        let lineData = this.getLineData(data, renderEnd);

        dom.find('defs clipPath polyline').attr('points', '0 30 ' + lineData.join(' ') + ' 100 30');
        dom.find('svg>polyline').attr('points', lineData.join(' '));
    },
    getLineData: function (data, cb) {
        let baseTime = data[0][0],
            hTime = data[data.length - 1][0] - baseTime,
            scope = hTime / 100000;

        let basePrice = data[0][1],
            hPrice = data[0][1];


        $.each(data, function (i, e) {
            let price = e[1];
            if (price < basePrice) {
                basePrice = price;
            }
            if (price > hPrice) {
                hPrice = price;
            }
        });
        let priceScope = (hPrice - basePrice)

        let dots = [];
        $.each(data, function (i, e) {
            e[0] = ((e[0] - baseTime) / 100000 / scope) * 100;
            e[1] = (1 - (e[1] - basePrice) / priceScope) * 30;
            dots.push(e.join(' '));
        });
        cb && cb(data);
        return dots;
    },
    scrollBanner: function (h, rota) {
        $('.zg-banner_module .list_wrapper').css({
            top: -$(window).scrollTop() * 0.3
        });
    }
};

function baseInitDo() {

    // scrollbar
    $('.zg-header .tabpanel_body .tabpanel_body-card').setScorllBar();

    $('.check_btn').click(function () {
        $(this).toggleClass('checked');
    });
}

function mainPageInitDo() {

    // owl
    $('.zg-banner_module .owl-slider').setOwlSlider({
        animateIn: 'fadeIn',
        animateOut: 'fadeOut'
    });
    $('.zg-news_module .owl-slider').setOwlSlider(3, {
        margin: 20,
        nav: true,
        dots: false,
        autoplay: false
    });

    // headerMin
    tools.showMinH();
    $(window).scroll(tools.showMinH);

    // animate
    $('.zg-news_module .list-item').setAnimate('news-wow', 'fadeInUp', {
        delay: '0.2',
        duration: '0.8s'
    }).run();
    $('.zg-currency_module .list-item').setAnimate('currency-wow', 'fadeInUp', {
        delay: '0.2',
        duration: '0.8s'
    }).run();
    $('.zg-app_module .image_wrapper').setAnimate('appimg-wow', 'fadeInLeft', {
        // offset: 100,
        duration: '1.2s'
    }).run();
    $('.zg-app_module .module_con').setAnimate('appcon-wow', 'fadeInRight', {
        // offset: 200,
        duration: '1.2s'
    }).run();
    $('.zg-security_module .header_title, .zg-security_module .header_subtitle, .zg-security_module .module_button').setAnimate('security-wow', 'fadeInUp', {
        delay: '0.2',
        duration: '0.8s'
    }).run();
    $('.zg-slogan_module  .list-item').setAnimate('security-wow', 'fadeInUp', {
        delay: '0.2',
        duration: '0.8s'
    }).run();

    // banner 视差
    tools.scrollBanner();
    $(window).scroll(tools.scrollBanner);

    // parax
    $('.zg-security_module  .cube1').parallaxDom(10, 4);
    $('.zg-security_module  .cube2').parallaxDom(20, 2);
    $('.zg-app_module .dot_wrapper').parallaxDom();

    // 渲染 svg line
    tools.renderTrendLine($('.zg-trade_module .charts').eq(0), function () {
        console.log('renderEnd');
    });
}

function tradeInitDo() {

    // 限价委托 面板切换
    let tradePanel = $('.zg-entrust_trade'),
        buyInforPanel = $('.zg-entrust_trade .trade_panel-buy .trade_panel-infor'),
        sellInforPanel = $('.zg-entrust_trade .trade_panel-sell .trade_panel-infor');

    $('.order_body .order_sell .td').click(function () {

        if (tradePanel.hasClass('isSell')) {

            sellInforPanel.tabClass('flash1', 'flash2');
        } else {

            tradePanel.removeClass('isBuy isSell').addClass('isSell');
        }
    });
    $('.order_body .order_buy .td').click(function () {

        if (tradePanel.hasClass('isBuy')) {

            buyInforPanel.tabClass('flash1', 'flash2');
        } else {

            tradePanel.removeClass('isBuy isSell').addClass('isBuy');
        }
    });

    tradePanel.find('.trade_panel-detail').click(function () {
        if ($(this).hasClass('trade_panel-buy')) {

            tradePanel.removeClass('isBuy isSell').addClass('isBuy');
        }
        if ($(this).hasClass('trade_panel-sell')) {

            tradePanel.removeClass('isBuy isSell').addClass('isSell');
        }
    });

    // 面板展示切换
    $('.order_body .sort_btns').on('click', '.btn', function () {
        
        $(this).siblings().removeClass('active');
        $(this).toggleClass('active');
        if ($(this).hasClass('buy_btn')) {
            $('.order_body').removeClass('tab_sell').toggleClass('tab_buy');
        }

        if ($(this).hasClass('sell_btn')) {
            $('.order_body').removeClass('tab_buy').toggleClass('tab_sell');
        }
    });
}

function pageEv(pageName, fn) {

    if ($('#ZGCOM').hasClass(pageName)) {
        fn && fn();
    }
}

$(function () {

    baseInitDo();

    pageEv('zg-mainpage', mainPageInitDo);
    pageEv('zg-trade', tradeInitDo);
});


// WEBPACK FOOTER //
// ./src/web/script/zg-script.js